const Constants = {

  applicationName: 'RansomStop',

  customerName: 'hiddenbranch',
  apiHost: 'hiddenbranch-api',
  domainName: 'ransomstop.com',
  userPoolId: 'us-east-1_Bp66KFYNx',
  userPoolClientId: '2vhu27u8pucoa27r9vmb7l56h',
  authDomain: 'hiddenbranch-ransomstop-com.auth.us-east-1.amazoncognito.com',
  region: 'us-east-1',
  invokeUrl: '',
  showBilling: true,

}
export default Constants
